<template>
  <v-dialog
    v-model="display"
    persistent
    width="1000"
  >
    <v-container class="remove-padding">
      <v-card>
        <v-toolbar
          color="primary"
          dark
          flat
        >
          <v-toolbar-title>Organisation Access - {{titleInfo}}</v-toolbar-title>
        </v-toolbar>
       
        <div class="org-access-content add-padding">
          <v-row align="center" justify="center">
            <v-col cols="12">
              <v-checkbox v-model="accessAll" label="Access All Organisations" />
            </v-col>
            <v-col cols="12">
              <span class="home-org">Home Organisation: {{ homeOrg }}</span>
            </v-col>
          </v-row>

          <v-row align="center" justify="center">
            <v-col cols="4" class="list-parent" fill-height>
              <h4>Available Organisations</h4>
              <div>
                <v-text-field
                  v-model="searchAvailableOrgs"
                  label="Search"
                  prepend-icon="mdi-magnify"
                ></v-text-field>
                <v-list dense :disabled="disabled">
                  <v-list-item-group
                    v-model="selectedAvailableOrgs"
                    multiple
                    color="primary"
                    class="list-container"
                  >
                  <div v-if="initLoad" class="cm-loader">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                  <div v-else>
                    <v-list-item
                      v-for="(org) in filteredOrgs"
                      :key="org.id"
                      :value="org"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{org.name}}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                  </v-list-item-group>
                </v-list>
              </div>
            </v-col>

            <!-- Action Buttons -->
            <v-col cols="2" class="d-flex fill-height align-center justify-center flex-column text-center">
              <v-btn :disabled="disabled" class="ma-2" outlined large fab color="green" @click="handleSelection">
                <v-icon>mdi-chevron-double-right</v-icon>
              </v-btn>
              <v-btn :disabled="disabled" class="ma-2" outlined large fab color="red" @click="reverseSelection">
                <v-icon>mdi-chevron-double-left</v-icon>
              </v-btn>
            </v-col>

            <v-col cols="4" class="list-parent">
              <h4>Accessible Organisations</h4>
              <div>
                <v-text-field
                  v-model="searchAccessibleOrgs"
                  label="Search"
                  prepend-icon="mdi-magnify"
                ></v-text-field>
                <v-list dense :disabled="disabled">
                  <v-list-item-group
                    v-model="selectedAccessibleOrgs"
                    multiple
                    color="primary"
                    class="list-container"
                  >
                    <div v-if="initLoad" class="cm-loader">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </div>
                    <div v-else>
                      <v-list-item
                        v-for="(org) in filteredAccessibleOrgs"
                        :key="org.id"
                        :value="org"
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            {{org.name}}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </v-list-item-group>
                </v-list>
              </div>
            </v-col>
          </v-row>
          
          <v-row>
            <v-spacer></v-spacer>
            <v-col
              cols="auto"
              class="mr-auto"
            >
              <v-btn text class="ctrl-btn cancel" @click="cancel">
                CANCEL
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn text class="ctrl-btn submit" :loading="loading" @click="submitHandler">
                SUBMIT
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
      <v-dialog v-model="showWarning" width="500">
        <v-card>
          <br>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="no-padding">
                <span class="warn-text">This will modify the organisation access of {{ userCount }} users.</span>
              </v-col>
              <v-col cols="12" class="no-padding">
                <span class="warn-text">Are you sure you wish to continue?</span>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn text class="ctrl-btn cancel" color="#0f74bb" @click="showWarning = false">
              NO
            </v-btn>
            <v-spacer/>
            <v-btn text class="ctrl-btn submit" color="#0f74bb" :loading="loading" @click="submit">
              YES
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    
  </v-dialog>
</template>

<script>

import { listOrgAccessForUsers,addOrgAccessForUsers, ListAccessibleOrgs } from '@/services/API.js'

import { Logger } from "aws-amplify"
const logger = new Logger("Org Access")

export default {
  name: 'OrgAccess',
  props: {
    display: {
      type: Boolean,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    orgs: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      accessAll: false,
      selectedAvailableOrgs: [],
      selectedAccessibleOrgs: [],
      accessibleOrgs: [],
      searchAvailableOrgs: '',
      searchAccessibleOrgs: '',
      initLoad: true,
      loading: false,
      showWarning: false,
      accessibleOrgsTest: []
    }
  },
  computed: {
    disabled() {
      return this.accessAll;
    },
    filteredAccessibleOrgs() {
      return this.accessibleOrgs.filter(item => {
        return item.name.toLowerCase().includes(this.searchAccessibleOrgs.toLowerCase())
      })
    },
    availableOrgs() {
      const isSameOrg = (a, b) => a.name === b.name

      const getDiff = (left, right, compareFunction) => 
        left.filter(leftValue =>
          !right.some(rightValue => 
            compareFunction(leftValue, rightValue)))
            
      const refinedOrgs = this.orgs.filter(org => org.name != this.homeOrg)
      const onlyInA = getDiff(refinedOrgs, this.accessibleOrgs, isSameOrg)
      const onlyInB = getDiff(this.accessibleOrgs, this.orgs, isSameOrg)
      const result = [...onlyInA, ...onlyInB]

      return result
    },
    filteredOrgs() {
      return this.availableOrgs.filter(item => {
        return item.name.toLowerCase().includes(this.searchAvailableOrgs.toLowerCase())
      })
    },
    userEmails() {
      return this.users.map(user => {
        return user.email
      })
    },
    userCount() {
      return this.users.length
    },
    accessibleOrgsIds() {
      return this.accessibleOrgs.map(org => {
        return org.id
      })
    },
    updatePayload() {
      const payload = {}

      this.userEmails.forEach(user => {
        payload[user] = this.accessibleOrgsIds
      })

      return payload
    },
    accessAllUserPayload() {
      return this.accessAll ? this.userEmails : []
    },
    titleInfo() {
      if(!this.userCount > 0) return

      const userName = this.users[0].Profile.firstname != null ? `${this.users[0].Profile.firstname} ${this.users[0].Profile.lastname}` : this.users[0].email
      const count = this.userCount - 1

      return this.userCount > 1 ? `${userName} + ${count} others` : userName
    },
    hasAccessToAll() {
      return this.orgs.length == this.accessibleOrgs.length ? true : false
    },
    homeOrg() {
      return this.users.length > 0 ? this.users[0].Org.name : ''
    }
  },
  watch: {
    display() {
      if(this.display) {
        this.listOrgAccessForUsers()
      }
    },
    hasAccessToAll(val) {
      if(val) {
        this.accessAll = true
      } else {
        this.accessAll = false
      }
    }
  },
  async mounted() {
    this.accessibleOrgsTest = await ListAccessibleOrgs()
  },
  methods: {
    async listOrgAccessForUsers() { 
      this.initLoad = true

      const list = await listOrgAccessForUsers(this.userEmails)
      let accessibleOrgsIds = []
      let accessibleOrgsObjs = []

      if(list && list.hasOwnProperty('users')) {
        let idList = Object.values(list.users)[0]

        accessibleOrgsIds = idList
      }

      accessibleOrgsIds.forEach(orgId => {
        let org = this.orgs.find(orgObj => orgObj.id == orgId)
        if(org && !accessibleOrgsObjs.includes(org)) {
          accessibleOrgsObjs.push(org)
        }
      })

      this.accessibleOrgs = accessibleOrgsObjs
      this.initLoad = false
    },
    cancel() {
      this.$emit('close')
      this.accessibleOrgs = []
      this.accessAll = false
    },
    handleSelection() {
      this.selectedAvailableOrgs.forEach(org => {
        if(!this.accessibleOrgs.includes(org)) {
          this.accessibleOrgs.push(org)
        }
      })
    },
    reverseSelection() {
      logger.info('reverse',)
      this.selectedAccessibleOrgs.forEach(org => {
        logger.info('org ', org)
        logger.info(this.accessibleOrgs, this.accessibleOrgs.indexOf(org))
        if(this.accessibleOrgs.indexOf(org) > -1) {
          logger.info('remove', org)
          this.accessibleOrgs = this.accessibleOrgs.filter(filterOrg => filterOrg.id != org.id)
        }
      })
    },
    submitHandler() {
      if (this.users.length > 1) {
        this.showWarning = true
      } else {
        this.submit()
      }
    },
    async submit() {
      logger.info('submit')
      this.loading = true
      const updateAccess = await addOrgAccessForUsers(this.updatePayload, this.accessAllUserPayload)
      logger.info('updateAccess', updateAccess)
      if(updateAccess && updateAccess.statusCode == 200) {
        this.loading = false
        this.showWarning = false
      }
      else {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
.remove-padding {
  padding: 0!important;
}
.add-padding {
  padding: 1em;
}

.no-padding {
  padding: 0 !important;
}

.warn-text {
  color: #0f74bb;
}

.home-org {
  font-size: 14px;
  padding-left: 5px;
  color: rgba(0, 0, 0, 0.6);
}

.list-parent {
  position: relative;
  background: #f2f2f2;
  .list-container {
    overflow-y: scroll;
    overflow-x: visible; /* Hide horizontal scrollbar */
    height: 500px;
    &::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: #aaa;
      transition: all .2s;

      &:hover {
        background: #999;
      }
    }
  }
}

.cm-loader {
  position: absolute;
  left: 45%;
  bottom: 45%;
}

.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100% !important;
}

</style>